import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../Sass/Common.scss";
import { ReactComponent as DeleteRoundIcon } from "Assets/Icons/PharmsmartIcon/DeleteRoundIcon.svg";
import { ReactComponent as ErrorIcon } from "../../Assets/Icons/PharmsmartIcon/ErrorIcon.svg";
import { ReactComponent as Urgent } from "Assets/Icons/PharmsmartIcon/Urgent.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import clsx from "clsx";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
// html-react-parser removed: static string now rendered as safe JSX
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        textAlign: "center",
        "&>h3": {
          textAlign: "center !important",
          marginTop: "30px !important",
          color: "red !important",
        },
      },
      "&>div": {
        "&>h4": {
          textAlign: "center !important",
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    paddingBottom: "0 !important",
    paddingTop: "0 !important",
    border: "0 !important",
  },

  TextBlack: {
    color: "#333 !important",
    fontSize: "18px !important",
    fontWeight: "400 !important",
    width: "95%",
    margin: "0 auto !important",
    textAlign: "center !important",
  },
  TextBlackMultiple: {
    color: "#333 !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    width: "70%",
    paddingRight: "2px",
    paddingLeft: "2px",
    whiteSpace: "nowrap",
    textAlign: "center !important",
  },
  dialogWidth: {},
  assignmultiple: {
    maxWidth: "100%",
    display: "flex",
    listStyle: "none",
    flexWrap: "wrap",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    "&>p": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "fit-content",
    },
  },
  multipleList: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  rsIconDesign: {
    "&>div": {
      "&>div": {
        "&>svg": {
          width: "32px",
          height: "32px",
        },
      },
      "&>h2": {
        fontSize: "18px !important",
        fontWeight: "600 !important",
      },
    },
  },
}));

const MaxSelectDialog = (props) => {
  const classes = useStyle();
  const { open, setOpen, setMultipleOrderDialog } = props;

  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = () => {
    setMultipleOrderDialog(true);
  };
  return (
    <>
      <Box className={classes.ModalHeading}>
        <Dialog
          className="RSxs_modal"
          maxWidth={"xs"}
          open={open}
          onClose={(e) => {
            if (e.key === "Escape") {
              handleClose();
            }
          }}
          BackdropProps={{
            classes: {
              root: "root",
            },
          }}
        >
          <Box
            // className="ConfirmPrimaryDialogTitle"
            className={clsx(
              classes.rsIconDesign,
              "ConfirmPrimaryDialogTitleBlack"
            )}
          >
            <PrimaryDialogTitle
              handleClose={handleClose}
              icon={ErrorIcon}
              title={"Warning"}
            />
          </Box>
          <Box className={clsx("rsNoteGrid", classes.resConfirmationBox)}>
            <DialogContent className="DialogContentBoxView">
              <Typography className={classes.TextBlack}>
                Maximum number of repeat orders you can create{" "}
                <b>in one go</b> is 100
              </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActionBtn}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                className="BtnGreen"
              >
                {"Add Repeat Orders?"}
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default MaxSelectDialog;
